(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('dashboardAppsStatus', ["path", "$q", "modulesDao", "policyDao", "secAppsStatusDao", "$timeout", "routeHelper", "base64", "odometerFormat", "feature", "securityEventsDao", "troubleshooting", "$location", "modulesManager", "saasStatusDao", "licensesManager", "sideMenuManager", "systemTasksDao", "systemTasksService", function (path, $q, modulesDao, policyDao, secAppsStatusDao, $timeout, routeHelper, base64, odometerFormat, feature, securityEventsDao, troubleshooting, $location, modulesManager, saasStatusDao, licensesManager, sideMenuManager, systemTasksDao, systemTasksService) {
        var zeroCounts = false;
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/apps-status').template('apps-status'),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.checkpointTheme = feature.checkpointTheme;
                $scope.widgetApi = {};
                $scope.policyIds = [];
                var eventsSaaSes = { ms_azure: true };
                var filterStates = [
                    'new',
                    'remediated'
                ];
                var intervalRefreshCount;
                var licensedUsersSaaSes = [
                    'office365_emails',
                    'google_mail'
                ];
                var saasHealthCache = {};
                var timeoutDeferred = $q.defer();
                // load static configurations on init
                loadSaasData();
                $scope.loadData = function () {
                    if (zeroCounts) {
                        loadSaasData();
                    }
                    return $q.when();
                };
                function eventsPathParams(saasName) {
                    var filters = [{
                            type: 'saas',
                            id: saasName
                        }];
                    _(filterStates).each(function (state) {
                        filters.push({
                            type: 'current_state',
                            id: state
                        });
                    });
                    return {
                        params: {},
                        qs: {
                            filters: base64.encode(JSON.stringify({
                                resolution: 'all',
                                filters: filters,
                                filterBy: ''
                            }))
                        }
                    };
                }
                $scope.saasClick = function (saas) {
                    if (feature.checkpointTheme) {
                        var p = eventsPathParams(saas.name);
                        routeHelper.redirectTo('security-events', p.params, { qs: p.qs });
                    } else {
                    }
                };
                function loadSaasData() {
                    $scope.policyIds = [];
                    var eventsData;
                    var saasList;
                    var policies;
                    var licenseCount = {};
                    var infoTags = {
                        'files_all': {},
                        'emails_all': {},
                        'active_users': {},
                        'users_internal': {},
                        'channels_all': {},
                        'conversations_all': {}
                    };
                    var office365OnboardingTask;
                    return $q.all([
                        modulesDao.getModules().then(function (response) {
                            saasList = _(response.data.apps_items.modules).chain().filter(function (app) {
                                return app.is_saas && app.state === 'active' && !app.gui_hidden;
                            }).map(function (app) {
                                var iconNameV2 = app.stack_icon_round ? 'icons-round/' + app.stack_icon_round : 'saas-icons/' + app.stack_icon;
                                return {
                                    name: app.name,
                                    label: app.label_short || app.label,
                                    img: path('gui-v2').img(iconNameV2),
                                    order: app.security_stack_order
                                };
                            }).sortBy('order').value();
                            saasList.forEach(function (saas) {
                                saas.health_check = saasHealthCache[saas.name];
                            });
                            if (troubleshooting.entityDebugEnabled() && $location.search().saascount) {
                                while (saasList.length < $location.search().saascount) {
                                    saasList = saasList.concat(angular.copy(saasList));
                                }
                                saasList = _(saasList).first($location.search().saascount);
                            }
                            var queries = [];
                            var saasesForEvents = _(saasList).filter(function (saas) {
                                return eventsSaaSes[saas.name];
                            });
                            if (saasesForEvents.length) {
                                queries.push(securityEventsDao.list().params({ 'groupBy': ['saas'].join(',') }).params({
                                    filterEnum_current_state: filterStates.join(','),
                                    filterEnum_saas: _(saasesForEvents).pluck('name').join(',')
                                }).then(function (response) {
                                    eventsData = _(response.data.rows).chain().map(function (row) {
                                        return [
                                            row.saas,
                                            row
                                        ];
                                    }).object().value();
                                }));
                            }
                            // showing licenses count tooltip in case limited license
                            if (sideMenuManager.limitedLicense()) {
                                queries.push(licensesManager.init().then(function () {
                                    _(licensedUsersSaaSes).each(function (saas) {
                                        if (licensesManager.getLicensesBySaas(saas)) {
                                            licenseCount[saas] = licensesManager.getLicensesBySaas(saas);
                                        }
                                    });
                                }).catch(_.noop));
                            }
                            // office365 on-boarding system task
                            if (feature.enableSystemTask && _(saasList).findIndex(function (saas) {
                                    return saas.name === 'office365_emails';
                                }) !== -1) {
                                queries.push(systemTasksDao.onboardingTask('office365_emails').then(function (task) {
                                    office365OnboardingTask = task.data;
                                }, function (err) {
                                    console.log('Couldn\'t get o365OnboardingTask', err);
                                }));
                            }
                            return $q.allSettled(queries);
                        }).then(function (data) {
                            if (feature.saasHealth) {
                                modulesDao.getModulesHealCheck(saasList.map(function (saas) {
                                    return saas.name;
                                })).then(function (response) {
                                    saasList.forEach(function (saas) {
                                        var saas_health = response.data[saas.name];
                                        if (saas_health) {
                                            //set icon
                                            switch (saas_health.status) {
                                            case 'warning':
                                                saas_health.iconClass = 'fa fa-exclamation-circle warning-badge';
                                                break;
                                            case 'starting':
                                                saas_health.iconClass = 'fa fa-stumbleupon-circle starting-badge';
                                                break;
                                            case 'error':
                                                saas_health.iconClass = 'fa fa-exclamation-circle error-badge';
                                                break;
                                            case 'ok':
                                                saas_health.iconClass = 'fa fa-check-circle ok-badge';
                                                break;
                                            default:
                                                saas_health.iconClass = 'fa fa-exclamation-circle warning-badge';
                                                break;
                                            }
                                            saasHealthCache[saas.name] = saas_health;
                                            saas.health_check = saas_health;
                                        }
                                    });
                                });
                            }
                        }),
                        policyDao.policyCatalog().params({ filterBy_tags: _(infoTags).keys().join(',') }).then(function (response) {
                            policies = _(response.data.rows).chain().filter(function (row) {
                                return row.policy_status === 'running';
                            }).reduce(function (memo, row) {
                                var saas = row.context.saas;
                                $scope.policyIds.push(row.policy_id);
                                _(row.tags).each(function (tag) {
                                    if (!infoTags[tag]) {
                                        return;
                                    }
                                    memo[saas] = memo[saas] || {};
                                    memo[saas][tag] = memo[saas][tag] || {
                                        policies: [],
                                        count: 0,
                                        countF: odometerFormat(0)
                                    };
                                    memo[saas][tag].count += row.counts_match_count;
                                    memo[saas][tag].countF = odometerFormat(memo[saas][tag].count);
                                    memo[saas][tag].policies.push(row);
                                });
                                return memo;
                            }, {}).value();
                        })
                    ]).then(function () {
                        zeroCounts = false;
                        _(saasList).each(function (saas) {
                            saas.autoId = 'dashboard_apps_status_' + saas.name;
                            if (policies[saas.name]) {
                                var usersData = policies[saas.name].active_users || policies[saas.name].users_internal;
                                if (saas.name === 'google_mail' && (!policies[saas.name] || !usersData) && policies.google_drive && (policies.google_drive.active_users || policies.google_drive.users_internal)) {
                                    usersData = policies.google_drive.active_users || policies.google_drive.users_internal;
                                }
                                if (saas.name === 'slack' && feature.enableSlackFeatures && policies.slack && policies.slack.files_all) {
                                    usersData = policies.slack.files_all;
                                }
                                if (usersData) {
                                    saas.active = {
                                        autoId: 'dashboard_apps_status_' + saas.name + '_active_users_count_' + (usersData.count || 0),
                                        label: 'Active Users',
                                        emptyLabel: 'Scanning Users...',
                                        count: usersData.count || 0,
                                        href: routeHelper.getHref('policy-edit', { id: usersData.policies[0].policy_id })
                                    };
                                    if (saas.name === 'slack' && feature.enableSlackFeatures) {
                                        saas.active.label = 'Total Files';
                                        saas.active.emptyLabel = 'Scanning Files...';
                                    }
                                    saas.active.countF = odometerFormat(saas.active.count);
                                    if (!saas.active.count) {
                                        zeroCounts = true;
                                    }
                                    if (licenseCount[saas.name] && usersData.count) {
                                        saas.active.tooltip = {
                                            content: { text: 'Limited license - not all of your users are being protected. ' + 'Assigned licenses: ' + licenseCount[saas.name] },
                                            position: {
                                                at: 'bottom center',
                                                my: 'top center'
                                            }
                                        };
                                    }
                                }
                                var totalData;
                                if (policies[saas.name].emails_all) {
                                    totalData = policies[saas.name].emails_all;
                                    totalData.label = 'Total Emails';
                                    totalData.emptyLabel = 'Scanning Emails...';
                                } else {
                                    if (policies[saas.name].files_all) {
                                        totalData = policies[saas.name].files_all;
                                        totalData.label = 'Total Files';
                                        totalData.emptyLabel = 'Scanning Files...';
                                    }
                                }
                                if (saas.name === 'slack' && feature.enableSlackFeatures && policies[saas.name].channels_all) {
                                    totalData = policies[saas.name].channels_all;
                                    totalData.label = 'Total Channels';
                                    totalData.emptyLabel = 'Scanning Channels...';
                                }
                                if (totalData) {
                                    saas.total = {
                                        label: totalData.label,
                                        emptyLabel: totalData.emptyLabel,
                                        count: totalData.count || 0,
                                        href: routeHelper.getHref('policy-edit', { id: totalData.policies[0].policy_id })
                                    };
                                    saas.total.countF = odometerFormat(saas.total.count);
                                }
                                if (!saas.total.count) {
                                    zeroCounts = true;
                                }
                            }
                            if (eventsSaaSes[saas.name] && eventsData[saas.name]) {
                                var p = eventsPathParams(saas.name);
                                saas.active = {
                                    label: 'Total Events',
                                    emptyLabel: 'No events',
                                    count: eventsData[saas.name].count || 0,
                                    href: routeHelper.getHref('security-events', p.params, p.qs)
                                };
                                saas.active.countF = odometerFormat(saas.active.count);
                            }
                            if (saas.name === 'office365_emails' && office365OnboardingTask) {
                                saas.onboarding = office365OnboardingTask;
                                //set icon
                                if (saas.onboarding.status === 'failed' || saas.onboarding.status === 'error') {
                                    saas.onboarding.iconClass = 'fa fa-cog error-badge';
                                } else if (saas.onboarding.status === 'inprogress') {
                                    saas.onboarding.iconClass = 'fa fa-spinner fa-pulse starting-badge';
                                } else {
                                    saas.onboarding.iconClass = 'fa fa-cog starting-badge';
                                }
                                if (saas.onboarding.name) {
                                    saas.onboarding.tip = saas.onboarding.name + ' - ' + saas.onboarding.status;
                                }
                                $scope.viewOnboardingActions = function (event, task) {
                                    event.stopPropagation();
                                    systemTasksService.viewActionsTable(task, 'office365_emails_onboarding');
                                };
                            }
                        });
                        $scope.saasList = saasList;
                        $timeout(alterSaaSWidths);
                        // this give core very heavy calls, so we shouldn't refresh the policy apis more often.
                        // current interval is 6h * 60mins * 60s * 1000ms
                        if (!intervalRefreshCount) {
                            refreshPolicyCount();
                            intervalRefreshCount = setInterval(refreshPolicyCount, 21600000);
                        }
                    });
                }
                function refreshPolicyCount() {
                    if ($scope.policyIds.length) {
                        timeoutDeferred.resolve();
                        timeoutDeferred = $q.defer();
                        // keep alive all policies
                        var refreshCountAPIs = [policyDao.pingForAll($scope.policyIds, true).timeout(timeoutDeferred.promise)];
                        _($scope.policyIds).each(function (id) {
                            // refresh count of policy
                            refreshCountAPIs.push(policyDao.refreshCount(id).timeout(timeoutDeferred.promise));
                            // update table of policy
                            refreshCountAPIs.push(policyDao.match(id).params({
                                page: 1,
                                per_page: 20
                            }).timeout(timeoutDeferred.promise));
                        });
                        $q.allSettled(refreshCountAPIs).then(function () {
                            loadSaasData();    // refresh widget
                        });
                    }
                }
                var prevMaxWidth = 0;
                var prevSpacersAmount = 0;
                $scope.saasItemWidth = 165;
                $scope.saasSpacers = [];
                function alterSaaSWidths() {
                    var list = element.find('.saas-status .list');
                    if (!list.length) {
                        return;
                    }
                    var maxWidth = 165;
                    var contentWidth = list[0].clientWidth - 1;
                    var items = list.find('.saas');
                    items.each(function (idx, item) {
                        maxWidth = Math.max(maxWidth, $(item).find('.item .inner').width());
                    });
                    $scope.saasItemWidth = maxWidth;
                    var spacersAmount = 0;
                    var itemsPerRow = Math.floor(contentWidth / maxWidth);
                    if (itemsPerRow < items.length) {
                        spacersAmount = (itemsPerRow - items.length % itemsPerRow) % itemsPerRow;
                    } else {
                        spacersAmount = Math.max(4 - items.length, 0);
                    }
                    if (prevSpacersAmount !== spacersAmount) {
                        $scope.saasSpacers = _(spacersAmount).range();
                    }
                    if (prevMaxWidth !== maxWidth || prevSpacersAmount !== spacersAmount) {
                        prevMaxWidth = maxWidth;
                        prevSpacersAmount = spacersAmount;
                        $timeout(alterSaaSWidths);
                    } else {
                        items.each(function (idx, item) {
                            item.style.visibility = 'visible';
                        });
                    }
                }
                element.on('resize', alterSaaSWidths);
                $scope.$on('$locationChangeStart', function () {
                    timeoutDeferred.resolve();
                    if (intervalRefreshCount) {
                        clearInterval(intervalRefreshCount);
                    }
                });
                $scope.$on('$destroy', function () {
                    element.off('resize', alterSaaSWidths);
                });
                $scope.$on('do-refresh-system-task-page', function () {
                    loadSaasData();
                });
            }
        };
    }]);
}());